import { THEMES } from '../../../utils/cms-utils';
import ThemeContainer from '../../../components/theme-container/ThemeContainer';
import Image from '../../../components/image/Image';
import TrackEventLink from '../../../components/track-event-link/TrackEventLink';
import styles from './kimh-2024-event-banner.module.less';
import { useSelector } from 'react-redux';

export const Kimh2024EventBanner = () => {
    const baseUrl = useSelector((state) => state.baseURL);
    return (
        <ThemeContainer mainColor={THEMES.SYRIN30} className={styles.banner}>
            <Image
                src={'/public/images/campaign/kimh2024/kimh2024-logo-blue.svg'}
                alt={'Klubben i mitt hjerte logo'}
                className={styles.logo}
            />
            <div>
                <p className={styles.text}>
                    Dugnaden er en del av Klubben i mitt hjerte, hvor det skal deles ut 300 000 kr. Lag en dugnad til
                    din idrettsklubb for å være med!
                </p>
                <TrackEventLink
                    to={`${baseUrl}/kimh`}
                    target={'_blank'}
                    category={'project_banner_kimh'}
                    action={'link_click'}
                >
                    Les mer om Klubben i mitt hjerte
                </TrackEventLink>
            </div>
        </ThemeContainer>
    );
};
